/* eslint-disable no-unused-vars */
import {
  Button,
  Col,
  DatePicker,
  Input,
  Modal,
  Row,
  Table,
  Typography,
  notification,
} from "antd";

import React, { useEffect, useRef, useState, useReducer } from "react";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import * as XLSX from "xlsx-js-style";
import moment from "moment";
import { BiExport, BiImport } from "react-icons/bi";
import SelectOption from "../../pos/components/SelectOption";
import { useHttp } from "../../../../hooks/http";
import { getToken, getUser, URL_API } from "../../../../utils";
import axios from "axios";
import TaxContexts, { reducer } from "../contexts/tax-contexts";
import PreviewImportModal from "../components/Modals/PreviewImportModal";
import ImportStatusModal from "../components/Modals/ImportStatusModal";
import { FaEye } from "react-icons/fa";

const { Text } = Typography;
const user = getUser();
const { Search } = Input;
const limit = 30;
const pageSize = 20;
const initState = {
  taxInfo: {
    tax_title: "",
    tax_year: "",
    company_name: "บริษัท เลกาซี่ คอร์ป จำกัด",
    company_address: "",
    company_tax: "0105557129609",
    account_code: "2307001",
    account_name: "ณัฐชนก ห้าวเหิม",
    sheet_name: "",
    file_name: "",
    tax_list: [],
  },

  modalPreviewTaxInfo: {
    visible: false,
  },
};

const Index = () => {
  const [state, dispatch] = useReducer(reducer, initState);
  const [memberTypeFilter, setMemberTypeFilter] = useState("");
  const [page, setPage] = useState(1);
  const [importPage, setImportPage] = useState(1);
  const [date_from, setDateFrom] = useState(moment());
  const [date_to, setDateTo] = useState(moment());
  const [search, setSearch] = useState("");
  const [modalStatusPage, setModalStatusPage] = useState(1);
  const [resImportStatusData, setResImportStatusData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const fileInputRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const source = axios.CancelToken.source();

  const importTemplate = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      const json = XLSX.utils.sheet_to_json(worksheet, {
        range: 1, // ข้าม header แถวแรก
        header: [
          "document_no",
          "document_date",
          "partner_code",
          "partner_name",
          "partner_address",
          "partner_tax",
          "partner_mobile",
          "tax_type",
          "total_amount",
          "tax_amount",
          "tax_amount_text",
        ],
        defval: "",
      });

      const duplicates = new Set();
      const seenKeys = new Set();
      const check_document = json.some((item) => item.document_no === "");
      if (check_document) {
        notification.error({
          message:
            "ไม่สามารถนำเข้าเอกสารข้อมูลได้ เนื่องจากมีบรรทัดที่ไม่มี DocumentNo",
        });
        return;
      }
      json.forEach((item) => {
        const key = item?.partner_code?.toString()?.trim() || ""; // ป้องกันกรณี null หรือช่องว่าง
        if (!key) return; // ข้ามถ้าไม่มีรหัส

        if (seenKeys.has(key)) {
          duplicates.add(key);
        } else {
          seenKeys.add(key);
        }
      });

      if (duplicates.size > 0) {
        const duplicateList = [...duplicates].join(", ");
        Modal.warning({
          title: "พบรหัสสมาชิกซ้ำ",
          content: `ตรวจพบรหัสสมาชิกซ้ำ: ${duplicateList} กรุณาแก้ไขก่อนนำเข้าข้อมูล`,
          okText: "ตกลง",
          zIndex: 1080, // ให้แน่ใจว่าแสดงอยู่บน modal อื่น
        });
        return; // ยกเลิกการทำงานต่อ
      }

      dispatch({
        type: "setTaxInfo",
        payload: {
          sheet_name: firstSheetName,
          file_name: file.name,
          tax_list: json,
        },
      });

      dispatch({
        type: "setPreviewImportModal",
        payload: { visible: true },
      });
    };

    reader.readAsArrayBuffer(file);
    event.target.value = null;
  };
  const handelView = async (tax_id) => {
    try {
      const res = await axios.get(`${URL_API}/import-document/tax/${tax_id}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });

      const data = res.data?.data;
      dispatch({
        type: "setTaxInfo",
        payload: {
          tax_title: data?.title,
          tax_year: data?.tax_year || "",
          company_name: data?.company_name || "บริษัท เลกาซี่ คอร์ป จำกัด",
          company_address: data?.company_address || "",
          company_tax: data?.company_tax || "",
          account_code: data?.account_code || "",
          account_name: data?.account_name || "",
          sheet_name: data?.sheet || "",
          file_name: data?.file_name || "",
          tax_list: data?.tax_list || [],
        },
      });

      dispatch({
        type: "setModalImportStatus",
        payload: {
          visible: true,
        },
      });
    } catch (error) {
      console.error("เกิดข้อผิดพลาดในการโหลดข้อมูล:", error);
      notification.error({
        message: "ไม่สามารถโหลดข้อมูลได้",
        description: "กรุณาลองใหม่อีกครั้งภายหลัง",
      });
    }
  };

  const [loading, data, error, reload] = useHttp(
    {
      url: `${URL_API}/import-document/tax/`,
      token: true,
      params: {
        limit,
        offset: limit * (page - 1),
        query: search,
        date_from: date_from ? moment(date_from).format("YYYY-MM-DD") : null,
        date_to: date_to ? moment(date_to).format("YYYY-MM-DD") : null,
        member_type_filter: memberTypeFilter,
      },
      initialLoad: true,
    },
    []
  );
  useEffect(() => {
    dispatch({
      type: "setTaxInfo",
      payload: {
        company_address: data?.address,
      },
    });
  }, [data]);

  useEffect(() => {
    // ตรวจว่า modal ถูกปิดเรียบร้อย (ไม่ใช่ null หรือ undefined)
    if (state.modalImportStatus?.visible === false) {
      reload();
    }
  }, [state.modalImportStatus?.visible]);

  return (
    <TaxContexts.Provider value={{ state, dispatch }}>
      <Panel>
        <PanelHeader>นำเข้าเอกสารภาษี</PanelHeader>
        <PanelBody>
          <input
            type="file"
            accept=".xlsx"
            ref={fileInputRef}
            onChange={importTemplate}
            style={{ display: "none" }}
          />

          <Row gutter={12} type="flex" className="align-items-center mb-3">
            <Col span={24}>
              <Row gutter={8} type="flex" justify="end" className="mb-2 mt-2">
                <Col>
                  <Button
                    type="ghost"
                    onClick={() => fileInputRef.current.click()}
                  >
                    <BiImport size={12} className="mr-2" />
                    Import Excel
                  </Button>
                </Col>
                {/* <Col>
                <Button type="primary" onClick={downloadTemplate}>
                  <BiExport size={12} className="mr-2" />
                  Export Template
                </Button>
              </Col> */}
              </Row>
            </Col>
          </Row>

          <Table
            bordered
            size="small"
            dataSource={data?.data.length > 0 ? data?.data : []}
            rowKey="row_id"
            loading={loading}
            scroll={{ x: "max-content" }}
            pagination={{
              current: page,
              pageSize: limit,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} จากทั้งหมด ${total} รายการ`,
              total: data?.data.length,
              showLessItems: true,
              size: "default",
              onChange: (currPage) => setPage(currPage),
            }}
          >
            <Table.Column title="#" dataIndex="row_id" align="left" />
            <Table.Column title="ไฟล์" dataIndex="file_name" align="left" />
            <Table.Column title="ชีท" dataIndex="sheet" align="left" />
            <Table.Column title="โดย" dataIndex="create_by" align="left" />
            <Table.Column
              title="วันที่"
              dataIndex="create_date"
              align="center"
              render={(date) => moment(date).format("DD/MM/YYYY HH:mm:ss")}
            />
            <Table.Column
              title=""
              dataIndex=""
              align="center"
              render={(_, record) => (
                <FaEye
                  style={{ cursor: "pointer", color: "#97D700" }}
                  onClick={() => {
                    handelView(record.id); // ส่ง ID ไปเรียก API
                  }}
                />
              )}
            />
          </Table>

          <PreviewImportModal />
          <ImportStatusModal />
        </PanelBody>
      </Panel>
    </TaxContexts.Provider>
  );
};

export default Index;
